// extracted by mini-css-extract-plugin
export var checkbox = "_31-0";
export var circle = "_31-3";
export var horizontalContainer = "_31-7";
export var sm = "_31-5";
export var switch0 = "_31-2";
export var switchDisabled = "_31-8";
export var switchEnabled = "_31-1";
export var textSwitchContainer = "_31-9";
export var textSwitchOption = "_31-a";
export var textSwitchOptionSelected = "_31-b";
export var verticalContainer = "_31-6";
export var xs = "_31-4";